import type { HTMLAttributes } from 'react'
import styles from './Text.module.css'

export type TextElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label'
export type TextSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
export type TextWeight = 'normal' | 'medium' | 'semibold' | 'bold'

export interface TextProps extends HTMLAttributes<HTMLElement> {
  as?: TextElement
  size?: TextSize
  weight?: TextWeight
  muted?: boolean
}

export function Text({
  as: Tag = 'p',
  size,
  weight,
  muted,
  className,
  ...props
}: TextProps) {
  const classes = [
    styles.text,
    size && styles[`size-${size}`],
    weight && styles[`weight-${weight}`],
    muted && styles.muted,
    className,
  ].filter(Boolean).join(' ')

  return <Tag className={classes} {...props} />
}
